// extracted by mini-css-extract-plugin
export default {"container":"vitual_container__wJlG6","leftarea":"vitual_leftarea__xRxmP","rightside":"vitual_rightside__qpNJP","beforeafter":"vitual_beforeafter__78Lm+"};